import { render, staticRenderFns } from "./ButtonAction.vue?vue&type=template&id=265fc33c&scoped=true&"
import script from "./ButtonAction.vue?vue&type=script&lang=js&"
export * from "./ButtonAction.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAction.vue?vue&type=style&index=0&id=265fc33c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265fc33c",
  null
  
)

export default component.exports